<template>
  <div class="horizontal layout center relative">
    <div
      class="count-answer"
      v-if="!$store.state.isScreenCapture"
      :class="{
        'has-reaction':
          $store.state.slideActive.type != 'openEnded' &&
          $store.state.slideActive.type != 'multipleChoice' &&
          $store.state.slideActive.type != 'wordCloud' &&
          $store.state.slideActive.type != 'qrcode' &&
          $store.state.slideActive.type != 'pickAnswer' &&
          $store.state.slideActive.type != 'leaderboard',
      }"
      v-hover-intent="{
        onEnter:() => handleHoverOnTheme('in'),
        onExit: () => handleHoverOnTheme('out'),
        exitDelay: 550,
        interval: 100
      }"
    >
      <i
        class="fas fa-user fa-fw"
        aria-hidden="true"
        :class="{ 'animate__bounceIn animate__animated': userCountAnimation }"
      />
      <span
        class="user-online-status"
        :class="{
          online: $store.state.userOnline > 0,
          'status-border': !isTextColourLight,
          warning: $store.state.onlineStatus == 2,
          danger: $store.state.onlineStatus == 3,
        }"
      />
      <span
        class="ml-0.5 relative"
      >{{ ($store.state.userOnline || 0) | formatTotalPoint }}
        <span
          class="show-limit-online "
          v-if="
            $store.state.plan &&
              $store.state.plan.group != 'white-label' &&
              $store.state.plan.group != 'pro' &&
              !$store.state.sharePresentation"
        >
          <span class="limit-slash">/</span>

          <span
            class="limit-number"
            v-if="planBenefit.name === 'free' &&
              (planBenefitLimitation.poll || planBenefitLimitation.quiz)"
          >
            3
          </span>
          <span class="limit-number" v-else>
            {{ planLimit }}
          </span>
        </span>

      </span>
    </div>
    <div
      class="absolute participant-limit-popup "
      :class="{
        'pro-popup': isProPlan || isWhiteLabel,
      }"
      v-hover-intent="{
        onEnter:() => handleHoverPopup('in'),
        onExit: () => handleHoverPopup('out'),
        exitDelay: 400
      }"
      v-if="isHoverShowParticipantPopup && !isDefaultShowTooltipForFreePlan && !isSharingView"
    >
      <div class="relative wrapper-popup arrow-bottom">
        <div>
          <SectionLive />
        </div>
        <div v-if="!(isProPlan || isWhiteLabel)" class="mt-4 body-live-section">
          <div v-if="isNewPricingAbTest" class="text-base-0 text-sm">
            <div class="mb-1">
              {{ $t("Only 3 can join") }}
              {{ $t('This presentation has exceeded the question limit for the Free Plan.') }}
            </div>
            <a
              href="https://help.ahaslides.com/portal/en/kb/articles/what-is-included-in-the-free-account"
              target="_blank"
              class="underline text-base-0 hover:text-primary-90 text-learn-more"
            >{{ $t('Learn more…') }}</a>
          </div>
          <span class="text-base-0" v-else>
            {{ $t("Up to {planLimit} participants", { planLimit }) }}
          </span>
          <div class="mt-3">
            <aha-antd-button
              :disabled="isPreview"
              variant="success"
              class="custom-button"
              @click="backToEditorAndOpenModalUpgrade('button')"
            >
              {{ $t('Upgrade for more') }}
            </aha-antd-button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="absolute participant-limit-popup animate__bounce animate__fadeInUp"

      style="width: 278px"
      v-if="isDefaultShowTooltipForFreePlan && plan === 'free'"
    >
      <div class="relative wrapper-popup arrow-bottom">
        <aha-icon
          name="close"
          class="close-icon cursor-pointer"
          @click="clickClose"
          width="18"
          height="18"
          viewBox="0 0 24 24"
        />

        <div>
          <SectionLive>
            <template #content>
              <span v-if="!isNewPricingAbTest">
                {{ $t("Up to {planLimit} participants", { planLimit }) }}
              </span>
              <span class="text-base-0" v-if="isNewPricingAbTest">
                {{ $t("Only 3 can join") }}
              </span>
            </template>
          </SectionLive>
          <div v-if="isNewPricingAbTest" class="mt-3">
            <p class="text-base-0 text-sm font-normal">
              <span class="block mb-1">
                {{ $t('This presentation has exceeded the question limit for the Free Plan.') }}
              </span>
              <a
                href="https://help.ahaslides.com/portal/en/kb/articles/what-is-included-in-the-free-account"
                target="_blank"
                class="underline text-base-0 hover:text-primary-90 text-learn-more"
              >{{ $t('Learn more…') }}</a>
            </p>
          </div>
        </div>
        <div v-if="!(isProPlan || isWhiteLabel)" class="mt-6">
          <aha-antd-button
            :disabled="isPreview"
            variant="success"
            class="custom-button"
            @click="backToEditorAndOpenModalUpgrade('button')"
          >
            {{ $t('Upgrade for more') }}
          </aha-antd-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { setTimeout } from 'timers'
import EventBus from '@/eventBus'
import SectionLive from './SectionLive.vue'
import eventCategories from '@/constant/eventCategories'
import {
  EDIT_MODE, FULL_SCREEN_MODE, SET_CURRENT_SLIDE_MODE, WINDOWED_MODE,
} from '@/vuex/types'
import util from '@/util'

export default {
  components: {
    SectionLive,
  },
  data() {
    return {
      userCountAnimation: false,
      isHoverShowParticipantPopup: false,
      isDefaultShowTooltipForFreePlan: false,
      flagCheckOutsidePopUp: false,
      countQRCodeVisible: 0,
    }
  },
  computed: {
    ...mapGetters(['isPresenting', 'planLimit', 'isTextColourLight']),
    ...mapGetters('zoomApp', ['isZoomReady']),
    ...mapState({
      isQRCodeVisible: (state) => state.isQRCodeVisible,
      plan: (state) => state.currentUser.plan,
      planBenefit: (state) => state.planBenefit,
      planBenefitLimitation: (state) => state.planBenefitLimitation,
    }),
    eventCategory() {
      if (this.isPreview) {
        return eventCategories.PRESENTATION_PREVIEW
      }
      if (this.isPresenting) {
        return eventCategories.PRESENTING_MODE
      }

      return eventCategories.PRESENTATION_EDITOR
    },
    isSharingView() {
      return this.$store.state.sharePresentation
    },
    isPreview: () => {
      // get params in url name isPreview
      const isEmbed = util.getParamValue('embedded')
      return isEmbed === 'true'
    },
    isWhiteLabel() {
      return this.$store.state.plan.group === 'white-label'
    },
    isProPlan() {
      return this.$store.state.plan.group == 'pro'
    },
    isNewPricingAbTest() {
      return this.planBenefit.name === 'free' && (this.planBenefitLimitation.poll || this.planBenefitLimitation.quiz)
    },
  },
  watch: {
    isHoverShowParticipantPopup(val) {
      if (val && !this.isDefaultShowTooltipForFreePlan && !this.isSharingView) {
        util.mixpanelTracking(this.eventCategory, 'Presenter > Hover over participants')
      }
    },
    isPresenting() {
      this.isShowTooltipForFreePlan()
    },
  },
  mounted() {
    this.isShowTooltipForFreePlan()
    const self = this
    EventBus.$on('userOnlineCount', () => {
      if (!self.userCountAnimation) {
        self.userCountAnimation = true
        setTimeout(() => {
          self.userCountAnimation = false
        }, 2000)
      }
    })
  },
  methods: {
    ...mapActions('zoomApp', [
      'detachPresentationToZoomMeetingAction',
    ]),
    handleHoverPopup(psudo) {
      if (psudo === 'in') {
        this.flagCheckOutsidePopUp = true
      }
      if (psudo === 'out') {
        this.flagCheckOutsidePopUp = false
        this.isHoverShowParticipantPopup = false
      }
    },
    isShowTooltipForFreePlan() {
      if (this.plan !== 'free' || !this.isPresenting || this.isSharingView) {
        this.isDefaultShowTooltipForFreePlan = false
        return
      }
      const isShow = (localStorage.getItem('isUserClosePopupForFreePlan') !== 'true')
      if (isShow) {
        util.mixpanelTracking(this.eventCategory,
          'Participant limit > Show tooltip')
      }
      this.isDefaultShowTooltipForFreePlan = isShow || this.isPreview
      if (this.isNewPricingAbTest) {
        this.isDefaultShowTooltipForFreePlan = true
      }
    },
    backToEditorAndOpenModalUpgrade(eventLabel) {
      util.mixpanelTracking(this.eventCategory,
        'Presenter > Upgrade for more', eventLabel)
      if (this.isPreview) {
        return true
      }
      return this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
    },
    clickClose() {
      localStorage.setItem('isUserClosePopupForFreePlan', 'true')
      this.isDefaultShowTooltipForFreePlan = false
      util.mixpanelTracking(this.eventCategory, 'Participant limit > Close tooltip')
    },

    backToEditor() {
      const mode = this.$store.getters.isFullScreenMode
        ? WINDOWED_MODE
        : FULL_SCREEN_MODE
      this.$store.dispatch(SET_CURRENT_SLIDE_MODE, mode)
      if (window.innerWidth > 800) {
        this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
        if (document.fullscreen && document.exitFullscreen) {
          document.exitFullscreen()
        }
      } else {
        this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
      }
      this.$router.replace({
        name: 'PresentationDetail',
        params: { id: this.$store.state.presentation.id },
      })
    },
    handleHoverOnTheme(psudo) {
      if (psudo === 'in') {
        this.isHoverShowParticipantPopup = true
      }
      if (psudo === 'out' && !this.flagCheckOutsidePopUp) {
        this.isHoverShowParticipantPopup = false
        this.flagCheckOutsidePopUp = false
      }
    },
  },

}
</script>
<style lang="scss" scoped>
.participant-limit-popup{
  font-family: Nunito;
  background:#0a0b19;
  top: 0px;
  left: 100%;
  transform: translate(-93%, -108.5%);
  width: 278px;
  box-shadow: 0px 6px 11px 0px rgba(0, 0, 0, 0.19);
  border:1px solid rgba(255, 255, 255, 0.20);
  border-radius: 14px;
  &.pro-popup{
    transform: translate(-93%, -127%);
    .arrow-bottom::before {
      right: 35px;
    }
  }

}
.close-icon{
  position: absolute;
  top: 12px;
  right: 12px;
    cursor: pointer;
    color: #999999;
    font-size: 14px;
    &:hover {
      color: #707070;
    }
}
.wrapper-popup{
  padding: 20px;
  &::before {
    content: "";
    width: 15px;
    height: 15px;
    transform: rotate(45deg);
    box-shadow: 1px 1px 0px rgba(255, 255, 255, 0.2);
    background:#0a0b19;
    position: absolute;
    z-index: -1;
  }
  /*
  Different arrow positioning
  */

  &.arrow-bottom::before {
    right: 54px;
    bottom: -7px;
  }
  &.arrow-bottom-free::before {
    right: 50px;
    bottom: -7px;
  }
}
.body-live-section{
  font-size: 16px;
}
.custom-button{
  padding-left: 1rem;
  padding-right: 1rem;
}

.count-answer{
  padding: 8px 0px;
}

.text-learn-more {
  color: #fff;
  text-decoration: underline;
}
</style>
